import React from 'react';
import {
  ContentFeedForHealthNews,
  ContentFeedForHealthNewsCardProps,
} from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { translationClasses } from 'src/shared/TranslationClasses';
import { GetContentFeedForHealthNewsModel } from './C21ContentFeedForHealthNews.service';
import {
  C21ContentFeedForHealthNewsParams,
  C21ContentFeedForHealthNewsProps,
} from './C21ContentFeedForHealthNews.types';
import { GetServerSideComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { fetchHealthNewsFeed } from 'src/shared/HealthNewsFeed';
import { getCheckbox } from 'src/shared/param-utils';
import { decodeHTML } from 'entities';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C21ContentFeedForHealthNewsProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  const model = GetContentFeedForHealthNewsModel(props);
  return (
    <ContentFeedForHealthNews
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export const getServerSideProps: GetServerSideComponentProps = async (_rendering) => {
  const params = _rendering.params as unknown as C21ContentFeedForHealthNewsParams;
  const posts = params?.APISlug
    ? await fetchHealthNewsFeed(params?.APISlug, parseInt(params?.NumberOfResults ?? '1'))
    : [];
  const cards: ContentFeedForHealthNewsCardProps[] = posts.map((post) => ({
    excerpt: post?.excerpt || '',
    headline: decodeHTML(post?.title || ''),
    shouldHideImagesOnMobile: getCheckbox(params?.HideImagesOnMobile),
    shouldHideSupportCopyOnCards: getCheckbox(params?.HideSupportCopyOnCards),
    imageSrc: post?.thumbnail_images?.full?.url || '',
    url: post?.url || '',
  }));

  return {
    cards: cards,
  };
};
